import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const sendUpsellAnnualFirstCtaSms = async ({
  callerId,
  force,
  immediate,
}: {
  callerId: string;
  force?: boolean;
  immediate?: boolean;
}) => {
  const response = await queryExecute({
    variables: {
      callerId,
      force,
      immediate,
    },
    query: graphql(`
      query SendUpsellAnnualFirstCtaSms($callerId: String!, $force: Boolean, $immediate: Boolean) {
        sendUpsellAnnualFirstCtaSms(callerId: $callerId, force: $force, immediate: $immediate)
      }
    `),
  });

  return response.data?.sendUpsellAnnualFirstCtaSms ?? false;
};
